import AddEventToCalendarModal from './AddEventToCalendarModal';

export default AddEventToCalendarModal;
